import { ShieldCheck, Eye, Wrench } from "lucide-react";
import { cn } from "@/lib/utils";

export const CLASSIFICATIONS = [
  "CUSTOMER SAFE",
  "INTERNAL STAFF ONLY",
  "TECHNICIAN / TRAINED STAFF ONLY",
];

const MAP = {
  "CUSTOMER SAFE": { cls: "bg-emerald-100 text-emerald-800 border-emerald-300", icon: ShieldCheck },
  "INTERNAL STAFF ONLY": { cls: "bg-amber-100 text-amber-800 border-amber-300", icon: Eye },
  "TECHNICIAN / TRAINED STAFF ONLY": { cls: "bg-red-100 text-red-800 border-red-300", icon: Wrench },
};

export default function Classification({ value, className = "" }) {
  if (!value) return null;
  const m = MAP[value] || MAP["INTERNAL STAFF ONLY"];
  const Icon = m.icon;
  return (
    <span data-testid="classification-badge"
      className={cn("inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-bold uppercase tracking-wide", m.cls, className)}>
      <Icon className="w-3.5 h-3.5" /> {value}
    </span>
  );
}
